export const Rights = [
    "WEB_MODULE_PILOT_ROTATION_WRITE"
]
